import { checkFeatureFlag } from '~/modules/helpers';

const defaultValues = {
    navigation: {
        lastViewedIncident: 0,
        lastViewedTriage: 0,
        incidentPlaybookView: 0
    },
    'war-room': {
        filterBoxes: []
    },
    'overview-layout': {
        overviewLayoutIndex: 1
    },
    'triage-tombstone': {
        fields: [
            {
                name: 'Status',
                field: 'status',
                selected: true
            }
        ]
    },
    'incident-tombstone': {
        fields: [
            {
                name: 'Opening time',
                field: 'openingtime',
                selected: true
            },
            {
                name: 'Type',
                field: 'type',
                selected: true
            },
            {
                name: 'Status',
                field: 'status',
                selected: true
            }
        ]
    },
    'incident-creation': {
        visibleColumns: [],
        rowActions: [],
        sortedColumn: [],
        rowOrder: 'table',
        query: []
    },
    'playbook-execution-result': {
        playbookView: 'list',
        sidebarCollapsed: true
    },
    'incident-runbook': {
        visibleColumns: [
            {
                headerName: 'Name',
                field: 'name',
                sortable: true,
                resizable: true,
                minWidth: 70,
                width: 120
            },
            {
                headerName: 'Status',
                field: 'status',
                sortable: true,
                resizable: true,
                minWidth: 70,
                width: 120
            },
            {
                headerName: 'Start',
                field: 'startdate',
                sortable: true,
                resizable: true,
                minWidth: 70,
                width: 120
            },
            {
                headerName: 'End',
                field: 'enddate',
                sortable: true,
                resizable: true,
                minWidth: 70,
                width: 120
            }
        ],
        rowActions: [
            'runbookResult',
            'kill',
            'run',
            'exportRunbookInternally',
            'delete'
        ],
        sortedColumn: [],
        rowOrder: 'table',
        query: []
    },
    'incident-templates-settings': {
        columns: [
            {
                field: 'id',
                hide: false
            },
            {
                field: 'name',
                hide: false
            },
            {
                field: 'category',
                hide: false
            },
            {
                field: 'tags',
                hide: false
            },
            {
                field: 'ready',
                headerName: 'Automation',
                hide: false
            }
        ],
        query: []
        /*
        rowActions: ['delete'],
        */
    },
    'incident-attachments': {
        columns: [
            {
                field: 'file_name',
                headerName: 'File name',
                hide: false
            },
            {
                field: 'file_type',
                headerName: 'File type',
                hide: false
            },
            {
                field: 'file_size',
                headerName: 'File size',
                hide: false
            },
            {
                field: 'folder',
                hide: false
            },
            {
                field: 'date',
                hide: false
            }
        ],
        query: []
    },
    'incident-timeline': {
        columns: [
            {
                field: 'title',
                hide: false
            },
            {
                field: 'category',
                hide: false
            },
            {
                field: 'updated_by',
                headerName: 'Created by',
                hide: false
            },
            {
                field: 'starttime',
                headerName: 'Start time',
                hide: false
            }
        ],
        query: [
            {
                name: 'Locked',
                value: 'locked:true',
                bookmark: true,
                selected: false
            },
            {
                name: 'Deleted',
                value: 'deleted:true',
                bookmark: true,
                selected: false
            }
        ]
    },
    'incident-objects': {
        columns: [
            {
                field: 'value',
                hide: false
            },
            {
                field: 'type',
                hide: false
            },
            {
                field: 'creation_date',
                headerName: 'Created',
                hide: false
            }
        ],
        query: [
            {
                name: 'IP Address',
                value: "type:'IP'",
                bookmark: false,
                selected: false
            },
            {
                name: 'Favorites',
                value: 'favorite:true',
                bookmark: true,
                selected: false
            },
            {
                name: 'Artifacts',
                value: 'type:artifact',
                bookmark: true,
                selected: false
            },
            {
                name: 'Locked',
                value: 'locked:true',
                bookmark: true,
                selected: false
            },
            {
                name: 'Deleted',
                value: 'deleted:true',
                bookmark: true,
                selected: false
            }
        ]
        /*
        rowActions: [
            'lock',
            'unlock',
            'delete',
            'restore',
            'favorite',
            'unfavorite'
        ],
        */
    },
    'incident-notes': {
        columns: [
            {
                field: 'title',
                hide: false
            },
            {
                field: 'tag',
                hide: false
            },
            {
                field: 'created_on',
                headerName: 'Created by',
                hide: false
            }
        ],
        query: [
            {
                name: 'Deleted',
                value: 'deleted:true',
                bookmark: true,
                selected: false
            }
        ]
        /*
        rowActions: [
            'export',
            'delete',
            'restore'
        ],
        */
    },
    'incident-tasks': {
        columns: [
            {
                field: 'title',
                hide: false
            },
            {
                field: 'status',
                hide: false
            }
        ],
        query: [
            {
                name: 'Mine',
                value: 'involved:true',
                bookmark: true,
                selected: false
            },
            {
                name: 'Closed',
                value: 'status:Closed',
                bookmark: true,
                selected: false
            },
            {
                name: 'Rejected',
                value: 'status rejected: 1 OR status rejected: 2',
                bookmark: true,
                selected: false
            },
            {
                name: 'Deleted',
                value: 'deleted:true',
                bookmark: true,
                selected: false
            }
        ]
        /*
        rowActions: [
            'export',
            'closeTask',
            'reopenTask',
            'authorizeTask',
            'notAuthorizeTask',
            'approveTask',
            'declineTask',
            'approveAndCloseTask'
        ],
        */
    },
    'incident-external-alert-list': {
        visibleColumns: [
            {
                headerName: 'Event',
                field: 'name',
                sortable: true,
                resizable: true
            },
            {
                headerName: 'Source',
                field: 'source',
                sortable: true,
                resizable: true
            },
            {
                headerName: 'Matched rule',
                field: 'matched_rules',
                sortable: true,
                resizable: true,
                minWidth: 70,
                width: 120
            }
        ],
        rowActions: [],
        sortedColumn: [],
        rowOrder: 'table',
        query: []
    },
    'incident-list': {
        columns: [
            {
                field: 'incidentid',
                hide: false
            },
            {
                field: 'status',
                hide: false
            },
            {
                field: 'starttime',
                hide: false
            }
        ],
        query: [
            {
                name: 'Mine',
                value: 'involved:true',
                bookmark: true,
                selected: false
            },
            {
                name: 'Deleted',
                value: 'deleted:true',
                bookmark: true,
                selected: false
            }
        ],
        occurrenceNumber: 500
        /*
        rowActions: [
            'runbookResult',
            'addInvestigator',
            'changeOwner',
            'cloneIncident',
            'delete',
            'restore',
            'grabIncident'
        ],
        */
    },
    'triage-list': {
        columns: [
            {
                field: 'id',
                headerName: '#',
                hide: false
            },
            {
                field: 'status',
                hide: false
            },
            {
                field: 'type',
                hide: false
            }
        ],
        query: [
            {
                name: 'Discarded',
                value: 'status:discarded',
                bookmark: true,
                selected: false
            }
        ],
        occurrenceNumber: 500
        /*
        rowActions: [
            'grab',
            'grabAndOpen',
            'discard',
            'reassign',
            'convertToIncident',
            'goToIncident'
        ],
        */
    },
    'entity-list': {
        columns: [
            {
                field: 'endvalue',
                hide: false
            },
            {
                field: 'tag',
                hide: false
            },
            {
                field: 'type',
                hide: false
            },
            {
                field: 'creation_date',
                hide: false
            },
            /*
            {
                field: 'involved_incidents',
                hide: true
            },
            */
            {
                field: 'deleted',
                hide: false
            },
            {
                field: 'locked',
                hide: false
            },
            {
                field: 'favorite',
                hide: false
            }
        ],
        query: [
            {
                name: 'IP Address',
                value: "type:'IP'",
                bookmark: true,
                selected: false
            },
            {
                name: 'Favorites',
                value: 'favorite:true',
                bookmark: true,
                selected: false
            },
            {
                name: 'Locked',
                value: 'locked:true',
                bookmark: true,
                selected: false
            },
            {
                name: 'Deleted',
                value: 'deleted:true',
                bookmark: true,
                selected: false
            }
        ],
        occurrenceNumber: 500
        /*
        rowActions: [
            'lock',
            'unlock',
            'delete',
            'restore',
            'favorite',
            'unfavorite'
        ]
        */
    },
    'dashboard-list': {
        uuid: window.crypto.randomUUID(),
        name: `Dashboard 1`,
        layout: []
    },
    'integrations-list': {
        columns: [
            {
                field: 'name',
                headerName: 'Integration',
                hide: false
            },
            {
                field: 'containment_names',
                headerName: 'Containment',
                hide: false
            },
            {
                field: 'enrichment_names',
                headerName: 'Enrichment',
                hide: false
            },
            {
                field: 'notification_names',
                headerName: 'Notification',
                hide: false
            }
        ],
        query: [
            {
                name: 'Deleted',
                value: 'deleted:true',
                bookmark: true,
                selected: false
            }
        ]
    },
    'integration-rules-settings': {
        columns: [
            {
                field: 'name',
                hide: false
            },
            {
                field: 'actions_name',
                headerName: 'Action',
                hide: false
            },
            {
                field: 'resource_name',
                headerName: 'resource',
                hide: false
            },
            {
                headerName: 'Last Update',
                field: 'last_updated',
                hide: false
            },
            {
                field: 'enabled',
                headerName: 'Status',
                hide: false
            }
        ],
        rowActions: ['runBtn', 'killBtn', 'reset', 'delete'],
        sortedColumn: [],
        rowOrder: 'table',
        query: []
    },
    'profiles-settings': {
        columns: [
            {
                field: 'name',
                hide: false
            },
            {
                field: 'last_update',
                headerName: 'Last update',
                hide: false
            }
        ],
        rowActions: ['delete', 'restore'],
        sortedColumn: [],
        rowOrder: 'table',
        query: []
    },
    'groups-settings': {
        columns: [
            {
                field: 'name',
                hide: false
            },
            {
                field: 'category',
                hide: false
            },
            {
                field: 'last_updated',
                headerName: 'Last update',
                hide: false
            }
        ],
        query: [
            {
                name: 'Deleted',
                value: 'deleted:true',
                bookmark: true,
                selected: false
            }
        ]
        /*
        rowActions: [
            'delete',
            'restore'
        ],
        */
    },
    'users-settings': {
        columns: [
            {
                field: 'name',
                hide: false
            },
            {
                field: 'surname',
                headerName: 'Surname',
                hide: false
            },
            {
                field: 'username',
                headerName: 'Username',
                hide: false
            },
            {
                field: 'last_updated',
                headerName: 'Last updated',
                hide: false
            }
        ],
        query: []
        /*
        rowActions: [
            'delete',
            'restore',
            'unlock',
            'lock'
        ],
        */
    },
    'queue-settings': {
        columns: [
            {
                field: 'name',
                hide: false
            },
            {
                field: 'mailing_List',
                hide: false
            }
        ],
        query: [
            {
                name: 'Deleted',
                value: 'deleted:true',
                bookmark: true,
                selected: false
            }
        ]
        /*
        rowActions: [
            'edit',
            'delete',
            'restore'
        ],
        */
    },
    'ark-settings': {
        visibleColumns: [
            {
                field: 'name',
                headerName: 'Name',
                selected: true
            },
            {
                field: 'type',
                headerName: 'Type',
                selected: true
            },
            {
                field: 'description',
                headerName: 'Description',
                selected: true
            }
        ],
        rowActions: ['delete'],
        query: [],
        sortedColumn: [],
        rowOrder: 'table'
    },
    'creation-automation': {
        visibleColumns: [
            {
                headerName: 'Name',
                field: 'name'
            },
            {
                headerName: 'Type',
                field: 'type'
            },
            {
                headerName: 'Description',
                field: 'description'
            },
            {
                headerName: 'Autorun',
                field: 'autorun'
            }
        ],
        rowActions: [],
        sortedColumn: [],
        rowOrder: 'table',
        query: []
    },
    'automation-runbook': {
        columns: [
            {
                field: 'name',
                hide: false
            },
            {
                field: 'description',
                hide: false
            },
            {
                field: 'type',
                hide: false
            },
            {
                field: 'deleted',
                hide: false
            },
            {
                field: 'last_updated',
                hide: false
            },
            /**
             * add status column in default columns if FF is enabled.
             * This will be used for all existing and new users.
             */
            ...(checkFeatureFlag('playbook_statusToggle')
                ? [
                      {
                          field: 'status',
                          hide: false
                      }
                  ]
                : [])
        ],
        query: [
            {
                name: 'Malware',
                value: 'type:malware',
                bookmark: true,
                selected: false
            },
            {
                name: 'Phishing',
                value: 'type:phishing',
                bookmark: true,
                selected: false
            },
            {
                name: 'Denial of Service',
                value: 'type:denial of service',
                bookmark: true,
                selected: false
            },
            {
                name: 'Deleted',
                value: 'deleted:true',
                bookmark: true,
                selected: false
            }
        ],
        /**
         * Default value for autosaved is true if FF is enabled.
         * Final value can be overwritten by value from the api.
         */
        ...(checkFeatureFlag('playbook_autosave') && {
            autosavePlaybookEnabled: true
        })
        /*
        rowActions: [
            'exportRunbook',
            'duplicateRunbook',
            'delete',
            'restore'
        ],
        */
    },
    'audit-trail': {
        columns: [
            {
                field: 'status',
                hide: false
            },
            {
                field: 'title_of_creation',
                hide: false
            },
            {
                field: 'date_of_creation',
                hide: false
            },
            {
                field: 'ip_of_creation',
                hide: false
            },
            {
                field: 'user_of_creation',
                hide: false
            }
        ],
        query: [
            {
                name: 'Warnings',
                value: 'status:warning',
                bookmark: true,
                selected: false
            },
            {
                name: 'Errors',
                value: 'status:error',
                bookmark: true,
                selected: false
            }
        ]
        /*
        rowActions: ['details'],
        */
    },
    'audit-logged-users': {
        columns: [
            {
                field: 'name',
                hide: false
            },
            {
                field: 'username'
                // hide: false
            },
            {
                field: 'email',
                hide: false
            },
            {
                field: 'role',
                hide: false
            },
            {
                field: 'last_activity',
                headerName: 'Last Activity',
                hide: false
            },
            {
                field: 'idle',
                headerName: 'Idle Time',
                hide: false
            }
        ],
        query: []
        /*
        rowActions: ['forceUserLogout'],
        */
    },
    'notification-queue': {
        columns: [
            {
                field: 'last_update',
                hide: false
            },
            {
                field: 'subject',
                hide: false
            },
            {
                field: 'body',
                hide: false
            },
            {
                field: 'to_recipients',
                hide: false
            },
            {
                field: 'cc_recipients',
                hide: false
            },
            {
                field: 'attempts',
                hide: false
            },
            {
                field: 'status',
                hide: false
            }
        ],
        query: []
        /*
        rowActions: [
            'details',
            'reschedule',
            'delete'
        ],
        */
    },
    'report-template': {
        columns: [
            {
                field: 'name',
                hide: false
            },
            {
                field: 'created_by',
                headerName: 'Created By',
                hide: false
            },
            {
                field: 'last_updated',
                headerName: 'Last Updated',
                hide: false
            }
        ],
        query: [
            //GB: We should add the deleted bookmark when WS work properly in this section
        ]
        /*
        rowActions: [
            'delete',
            'restore'
        ],
        */
    },
    'custom-fields': {
        columns: [
            {
                field: 'name',
                hide: false
            },
            {
                field: 'internalName',
                hide: true
            },
            {
                field: 'type',
                hide: false
            },
            {
                field: 'value',
                hide: false
            }
        ],
        query: []
        /*
        rowActions: [],
        */
    },
    'playbook-executions-list': {
        columns: [
            {
                field: 'name',
                hide: false
            },
            {
                field: 'status',
                hide: false
            },
            {
                field: 'trigger',
                hide: false
            },
            {
                field: 'start_time',
                hide: false
            },
            {
                field: 'end_time',
                hide: false
            },
            {
                field: 'duration',
                hide: false
            }
        ],
        query: []
    }
};
export default defaultValues;

export const defaultValuesKeys = Object.keys(defaultValues);

// prettier-ignore
export const homeDashboard = {
    dashboards: [
        {
            name: 'Home',
            widgets: [
                {
                    id: 0,
                    type: 'available-operations',
                    title: 'My Operations',
                    options: {
                        filters: [
                            {
                                types: [
                                    'task_created',
                                    'task_assigned',
                                    'task_to_authorize',
                                    'user_choice'
                                ],
                                user_id:
                                    CURRENT_USER.id
                            }
                        ],
                        ark_show: false,
                        order_by: 'newest'
                    }
                }
            ]
        }
    ]
};
